import { FC, useEffect, useState } from "react";
import { capitalize } from "~/utils";
import { ClientStatus } from "~/utils/constants";
import { useClientStore } from "./clients.store";

type Props = {};

export const TabClients: FC<Props> = () => {
  const { filters, setFilters } = useClientStore();
  const [activeTab, setActiveTab] = useState<ClientStatus | "all">(
    filters.status || "all"
  );

  useEffect(() => {
    setFilters({ status: activeTab === "all" ? undefined : activeTab, page: 1 });
  }, [activeTab, setFilters]);

  return (
    <div className="bg-white rounded-lg border mb-6 shadow-sm">
      <div className="flex border-b">
        <button
          className={`px-4 py-3 font-medium ${activeTab === "all"
              ? "text-blue-600 border-b-2 border-blue-600"
              : "text-gray-600 hover:text-gray-800"
            }`}
          onClick={() => setActiveTab("all")}
        >
          All Clients
        </button>
        {Object.values(ClientStatus).map((status) => (
          <button
            key={status}
            className={`px-4 py-3 font-medium ${activeTab === status
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-600 hover:text-gray-800"
              }`}
            onClick={() => setActiveTab(status)}
          >
            {capitalize(status)}
          </button>
        ))}
      </div>
    </div>
  );
};
